import React from 'react';
import './LegalPages.css';

const PrivacyPolicy = () => {
    return (
        <div className="legal-page-container">
            {/* 1. Header Banner */}
            <section className="legal-hero-banner">
                <h1 className="legal-hero-title">PRIVACY POLICY</h1>
                <p className="legal-hero-effective-date">Effective Date: July 18, 2026</p>
            </section>

            {/* 2. Main Body Content */}
            <div className="legal-content-wrapper">
                <div className="legal-container-max">
                    <p className="legal-paragraph">
                        Iconic Unity Group ("we," "our," or "us") respects your privacy and is committed to protecting the personal and corporate information you provide to us. This Privacy Policy explains how we collect, use, store, and safeguard your information when you interact with our platform at <strong id='info-color'>iconicunitygroup.com</strong>, submit business proposals, or engage with our corporate services.
                    </p>
                    <p className="legal-paragraph">
                        Please read this Privacy Policy carefully. If you do not agree with the terms of this privacy policy, please do not access or use the site.
                    </p>

                    <h3 className="legal-section-title">Information Collection and Use</h3>
                    <p className="legal-paragraph">
                        When you submit a business proposal, inquiry, or partnership form, we may collect information to verify your identity, evaluate joint ventures, or communicate regarding group updates:
                    </p>
                    <ul className="legal-bullet-list">
                        <li>Full Name, Designation, and Company Name</li>
                        <li>Telephone Number, Email Address, and Official Contact Details</li>
                        <li>Corporate/Billing Address and Project Location Details</li>
                        <li>Business Proposals, Investment Interests, and Partnership Requirements</li>
                        <li>Derivative Data (IP address, browser type, and access times collected automatically)</li>
                    </ul>

                    <h3 className="legal-section-title">How We Collect Your Information</h3>
                    <p className="legal-paragraph">
                        We collect information through official web forms, direct email communications, business investment inquiries, phone calls, corporate events, and direct engagements across our sister concerns.
                    </p>

                    <h3 className="legal-section-title">Use of Information</h3>
                    <p className="legal-paragraph">
                        We use the collected information to assess business partnerships, provide corporate governance support, respond to official inquiries, manage inter-company operational updates, evaluate investment feasibility, and deliver official communications as permitted by law.
                    </p>

                    <h3 className="legal-section-title">Sharing of Information Across Sister Concerns</h3>
                    <p className="legal-paragraph">
                        We do not sell or rent your personal information to third parties. We may share relevant information within our network of Sister Concerns (e.g., Iconic Express, Iconic Greenland, Iconic Soft, Iconic Furniture, Iconic Digital Solution, Iconic Motors) or authorized advisors exclusively for operational evaluation, legal compliance, or project execution.
                    </p>

                    <h3 className="legal-section-title">Data Protection and Security</h3>
                    <p className="legal-paragraph">
                        We take reasonable technical, administrative, and organizational measures to safeguard your information from unauthorized access, loss, or misuse. However, please note that no transmission over the internet or storage system can be guaranteed to be 100% secure.
                    </p>

                    <h3 className="legal-section-title">Your Rights and Choices</h3>
                    <p className="legal-paragraph">
                        You may contact our corporate office at any time to request access to your personal/business data, request corrections, or ask for the deletion of your contact records from our active database.
                    </p>

                    <hr className="legal-divider" />

                    {/* Contact Section */}
                    <div className="legal-contact-section">
                        <h3 className="legal-section-title">Contact Us</h3>
                        <p className="legal-paragraph">
                            If you have any questions or concerns regarding this Privacy Policy, please reach out to us:
                        </p>
                        <div className="legal-contact-details">
                            <strong>Iconic Unity Group</strong><br />
                            <strong>Address:</strong> Suite: 8/A&B, LilyPond Center, 3, R. K. Mission Road, Motijheel, Dhaka-1000, Bangladesh<br />
                            <strong>Hotline:</strong> <span id='info-color'>01824800900</span> | <strong>Phone:</strong> <span id='info-color'>01711183777</span><br />
                            <strong>Email:</strong> <span id='info-color'>info@iconicunitygroup.com</span><br />
                            <strong>Website:</strong> <span id='info-color'>www.iconicunitygroup.com</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;